import vMasker from "./vanilla-masker";
export const MASK_INTEGER = "NUMBER";
export const MASK_PHONE_NUMBER = "999-999-9999";
export const MASK_SSN_EDIT_MODE = "999-99-9999";
export const MASK_SSN_READONLY_MODE = {
  pattern: "***-**-9999",
  last: 4
};
export const MASK_TAX_ID = "99-9999999";
export const MASK_DATE = "99/99/9999";
export const MASK_PERCENTAGE = "PERCENTAGE";
export const MASK_CURRENCY = "MONEY";
export const MASK_BOOLEAN = "BOOLEAN";
const maskMapByFieldName = {
  "Social Security": MASK_SSN_EDIT_MODE,
  "Business TaxId": MASK_TAX_ID
};
const maskMapByFieldNameReadOnly = {
  "Social Security": MASK_SSN_READONLY_MODE
};
const maskMapByDataType = {
  Date: MASK_DATE,
  Percentage: MASK_PERCENTAGE,
  Currency: MASK_CURRENCY,
  Integer: MASK_INTEGER,
  Miles: MASK_INTEGER,
  Boolean: MASK_BOOLEAN
};
const maskMap = {
  getMaskFor: value => {
    if (value.DataElement && maskMapByFieldName.hasOwnProperty(value.DataElement.Name)) {
      if (maskMapByFieldNameReadOnly.hasOwnProperty(value.DataElement.Name)) {
        return {
          hasMask: true,
          editMask: maskMapByFieldName[value.DataElement.Name],
          readMask: maskMapByFieldNameReadOnly[value.DataElement.Name]
        };
      } else {
        return {
          hasMask: true,
          readEditMask: maskMapByFieldName[value.DataElement.Name]
        };
      }
    } else if (value.DataElement && maskMapByDataType.hasOwnProperty(value.DataElement.DataType)) {
      return {
        hasMask: true,
        readEditMask: maskMapByDataType[value.DataElement.DataType]
      };
    } else if (value.ControlName && value.ControlName.toLowerCase().indexOf("phone") > -1) {
      return {
        hasMask: true,
        readEditMask: MASK_PHONE_NUMBER
      };
    } else {
      return {
        hasMask: false
      };
    }
  },
  getMaskForDataElement: (de, immutable) => {
    let name = immutable ? de.get("Name") : de.Name;
    let dataType = immutable ? de.get("DataType") : de.DataType;
    if (de && maskMapByFieldName.hasOwnProperty(name)) {
      if (maskMapByFieldNameReadOnly.hasOwnProperty(name)) {
        return {
          hasMask: true,
          editMask: maskMapByFieldName[name],
          readMask: maskMapByFieldNameReadOnly[name]
        };
      } else {
        return {
          hasMask: true,
          readEditMask: maskMapByFieldName[name]
        };
      }
    } else if (de && maskMapByDataType.hasOwnProperty(dataType)) {
      return {
        hasMask: true,
        readEditMask: maskMapByDataType[dataType]
      };
    } else {
      return {
        hasMask: false
      };
    }
  },
  getMaskedValue: (value, mask, inEditMode) => {
    if (mask === MASK_CURRENCY) return vMasker.toMoney(value, {
      precision: 2,
      separator: ".",
      delimiter: ",",
      unit: "$",
      suffixUnit: "",
      zeroCents: true
    }, inEditMode);else if (mask === MASK_BOOLEAN) return value === "1" || value === 1 || value === true || value.toLowerCase() === "true" ? true : false;else if (mask === MASK_INTEGER) return vMasker.toNumber(value);else if (mask === MASK_PERCENTAGE) return vMasker.toPercentage(value, {
      precision: 2,
      extraPercentDecimals: true
    });else {
      return vMasker.toPattern(value, mask);
    }
  }
};
export default maskMap;